import { useCallback, useEffect } from "react";

// TODO: remove second static value in final commit
const SHARP_SPRING_ACCOUNT_ID = process.env.REACT_APP_SHARP_SPRING_ACCOUNT_ID;
const SHARP_SPRINT_APP_ID = "koi-3QNU720VCW";

/**
 * A component that inject SharpSprint script to document body.
 *
 * @returns {JSX.Element}
 */
const SharpSpringScriptLoader = () => {
  /**
   * Inject SharpSpring script into document body only if logged-in user is not a guest user.
   *
   * @param {boolean} _isGuestUser - Whether logged-in user is guest.
   *
   * @returns {HTMLScriptElement | undefined}
   */
  const injectSharpSpringScript = useCallback(() => {
    window._ss = window._ss || [];
    window._ss.push([
      "_setDomain",
      "https://" + SHARP_SPRINT_APP_ID + ".marketingautomation.services/net",
    ]);
    window._ss.push(["_setAccount", SHARP_SPRING_ACCOUNT_ID]);
    window._ss.push(["_trackPageView"]);

    const script = document.createElement("script");

    script.id = "sharp-spring-script";
    script.type = "text/javascript";
    script.src = "https://" + SHARP_SPRINT_APP_ID + ".marketingautomation.services/client/ss.js?ver=2.4.0";
    script.async = true;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    script.onerror = (e) => {
      console.info("Failed to load SharpSpring script:", e);
    };

    script.onload = (e) => {
      console.info("SharpSpring script loaded");
    };

    return script;
  }, []);

  useEffect(() => {
    const injectedScript = injectSharpSpringScript();

    return () => {
      if (injectedScript && document.getElementById("sharp-spring-script")) {
        document.getElementById("sharp-spring-script").remove();
      }
    };
  }, [injectSharpSpringScript]);

  /**
   * Do not return anything as this is a just script load component.
   */
  return null;
};

export default SharpSpringScriptLoader;
